import {Injectable, inject} from '@angular/core';
import {LocalStorageService} from '@services/local-storage/local-storage.service';
import {User} from '@interfaces/user';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserStorageService {

  private readonly USER_KEY = 'user_data';
  private local_storage_service = inject(LocalStorageService);
  private userSubject = new BehaviorSubject<User | null>(null);
  user$ = this.userSubject.asObservable();

  constructor() {
    this.loadUserFromStorage();
  }

  async setUserStorage(user: User): Promise<void> {
    await this.local_storage_service.setItem(this.USER_KEY, JSON.stringify(user));
    this.userSubject.next(user);
  }

  async getUserStorage(): Promise<User | null> {
    const data = await this.local_storage_service.getItem(this.USER_KEY);
    //return data ? JSON.parse(data) as User : null;
    const user = data ? JSON.parse(data) as User : null;
    this.userSubject.next(user); 
    return user;
  }

  removeUserStorage(): void {
    this.local_storage_service.removeItem(this.USER_KEY);
    this.userSubject.next(null);
  }

  private async loadUserFromStorage(): Promise<void> {
    await this.getUserStorage();
  }

}
